import { Component, OnInit } from '@angular/core';
import { CookieXSRFStrategy } from '@angular/http';
import { Router } from '@angular/router';
import { LocatelliHomeService } from '../../services/locatelliHome.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'topnavbar',
  templateUrl: './topnavbar.component.html'

})

export class TopnavbarComponent implements OnInit {
  baseUrl;
  pathStructure;
  pathLogout
  constructor(private router: Router, private locatelliService: LocatelliHomeService) { }

  ngOnInit() {
    this.baseUrl = environment.baseUrl
    this.pathLogout = environment.restBaseUrl + 'logout';
  }

  goToLocatelliAtHome() {
    window.location.href = environment.restBaseRedirect + 'home';
  }



  Logout() {

   //this.goToLocatelliAtHome()
    this.locatelliService.logout(this.pathLogout).subscribe(
      (response) => {

      if (response.outcome.success === true) {
        this.goToLocatelliAtHome()
    } else {
      this.goToLocatelliAtHome()
    }

      },
      (error) => {
        this.goToLocatelliAtHome()
      }
      );
  }






}



// WEBPACK FOOTER //
// ./src/app/common/topnavbar/topnavbar.component.ts